"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../../../shared");
var DatePickerMonth_meta_1 = require("./DatePickerMonth.meta");
var DatePickerUtils_1 = require("../../DatePickerUtils");
var DatePickerDay_1 = __importDefault(require("../DatePickerDay"));
var Table_1 = __importDefault(require("../../styledComponents/DatePickerMonth/Table"));
var TableHead_1 = __importDefault(require("../../styledComponents/DatePickerMonth/TableHead"));
var TableRow_1 = __importDefault(require("../../styledComponents/DatePickerMonth/TableRow"));
var TableHeadCell_1 = __importDefault(require("../../styledComponents/DatePickerMonth/TableHeadCell"));
var TableBody_1 = __importDefault(require("../../styledComponents/DatePickerMonth/TableBody"));
var TableCell_1 = __importDefault(require("../../styledComponents/DatePickerMonth/TableCell"));
var Translate_1 = require("../../../Translate/Translate");
function chunk(array, chunkSize) {
    var result = [];
    for (var i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
    }
    return result;
}
function mapWithOffset(array, startingOffset, mapFn) {
    return array.map(function (_, i) {
        var adjustedIndex = (i + startingOffset) % array.length;
        return mapFn(array[adjustedIndex]);
    });
}
var DatePickerMonth = /** @class */ (function (_super) {
    __extends(DatePickerMonth, _super);
    function DatePickerMonth(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = DatePickerMonth_meta_1.DATE_PICKER_MONTH_CATEGORY_KEY;
        _this.componentKey = DatePickerMonth_meta_1.DATE_PICKER_MONTH_COMPONENT_KEY;
        return _this;
    }
    Object.defineProperty(DatePickerMonth.prototype, "parentComponentKey", {
        get: function () {
            return DatePickerMonth_meta_1.DATE_PICKER_MONTH_PARENT_COMPONENT_KEY;
        },
        enumerable: true,
        configurable: true
    });
    DatePickerMonth.prototype.render = function () {
        var _a = this.props, selectedDate = _a.selectedDate, focusedDate = _a.focusedDate, labelledById = _a.labelledById, localization = _a.localization, firstDayOfWeek = _a.firstDayOfWeek, min = _a.min, max = _a.max, dateFormatter = _a.dateFormatter, isDateDisabled = _a.isDateDisabled, onDateSelect = _a.onDateSelect, onKeyboardNavigation = _a.onKeyboardNavigation, focusedDayRef = _a.focusedDayRef;
        var today = new Date();
        var days = DatePickerUtils_1.getViewOfMonth(focusedDate, firstDayOfWeek);
        return (react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
            var translate = translationContext.translate;
            return react_1.default.createElement(Table_1.default, { className: "table", "aria-labelledby": labelledById },
                react_1.default.createElement(TableHead_1.default, null,
                    react_1.default.createElement(TableRow_1.default, null, mapWithOffset(localization.dayNames, firstDayOfWeek, function (dayName) {
                        var translatedDayName = translate(dayName);
                        return react_1.default.createElement(TableHeadCell_1.default, { key: translatedDayName, className: "table-header", scope: "col" },
                            react_1.default.createElement("span", { "aria-hidden": "true" }, translatedDayName.substring(0, 2)),
                            react_1.default.createElement("span", { className: "vhidden" }, translatedDayName));
                    }))),
                react_1.default.createElement(TableBody_1.default, null, chunk(days, 7).map(function (week, index) { return (react_1.default.createElement(TableRow_1.default, { key: "week-" + index, className: "row" }, week.map(function (day) { return (react_1.default.createElement(TableCell_1.default, { key: "week-" + index + day, className: "cell" },
                    react_1.default.createElement(DatePickerDay_1.default, { day: day, today: today, focusedDay: focusedDate, isSelected: DatePickerUtils_1.isEqual(day, selectedDate), disabled: isDateDisabled(day), inRange: DatePickerUtils_1.inRange(day, min, max), onDaySelect: onDateSelect, dateFormatter: dateFormatter, onKeyboardNavigation: onKeyboardNavigation, focusedDayRef: focusedDayRef }))); }))); })));
        }));
    };
    DatePickerMonth = __decorate([
        mobx_react_1.observer
    ], DatePickerMonth);
    return DatePickerMonth;
}(shared_1.ComponentBase));
exports.DatePickerMonth = DatePickerMonth;
exports.default = shared_1.InjectedStyledComponent(DatePickerMonth, DatePickerMonth_meta_1.DATE_PICKER_MONTH_CATEGORY_KEY, DatePickerMonth_meta_1.DATE_PICKER_MONTH_PARENT_COMPONENT_KEY, [DatePickerMonth_meta_1.DATE_PICKER_MONTH_COMPONENT_KEY]);
